<template>
  <div id="contenedor">
    <v-layout row wrap="">
      <v-flex xs12 sm12 md12>
        <v-card class="table" elevation="4">
          <v-toolbar flat elevation="4">
            <v-card class="icon">
                <v-icon style="margin-left:30px; margin-top:25px" color="white" x-large="">mdi-account-convert</v-icon>
            </v-card>
            <div class="usuario">CARGOS</div>
              <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="700px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn dark class="botonplus" v-on="on"><v-icon color="white">mdi-plus-thick</v-icon></v-btn>
              </template>
                <v-card style="display: flex; flex-direction: column; max-height: 85vh;">
                  <v-card-title class="nav" style="flex-shrink: 0;">
                      <span class="headline" style="color:whitesmoke"><v-icon color="white">mdi-account-convert</v-icon> {{ formTitle }}</span>
                  </v-card-title>
                  <!-- componente del modal para agregar y actualizar -->
                  <v-card-text style="flex: 1 1 auto; overflow-y: auto; min-height: 0; max-height: 50vh;">
                    <v-container grid-list-md>
                      <v-layout wrap>
                          <v-flex xs12 sm6 md6>
                            <v-select
                              item-value="cc_id_area"
                              item-text="cc_nombre_area"
                              :items="areas"
                              label="Areas"
                              v-model="editedItem.idArea"
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <v-text-field v-model="editedItem.nombreCargo" label="Cargo"></v-text-field>
                          </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <!-- botones para cancelar y agregregar y validacion de campos vacios -->
                  <v-card-actions style="flex-shrink: 0;">
                    <v-spacer></v-spacer>
                      <v-btn color="#1D3C7F"  dark @click="close">Cancelar</v-btn>
                      <v-btn
                      color="#1D3C7F"
                      dark
                      @click="save"
                      :disabled="!editedItem.idArea || !editedItem.nombreCargo"
                      >Guardar</v-btn>
                  </v-card-actions>
                  <!-- <pre>{{editedItem}}</pre>  -->
                </v-card>
            </v-dialog>
          </v-toolbar> 
          <br>
          <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar Cargos"
          single-line
          class="text-field"
          color="#111c3d"
          ></v-text-field>
          <br>
          <v-data-table 
          :headers="headers" 
          :items="cargos" 
          :search="search"
          style=" border: 2px solid #111c3d;"
          class="elevation-3"
          >
          <!-- tabla donde se pintan los datos obtenidos del arreglo -->
          <template v-slot:item.action="{ item }">
            <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
            >
            mdi-pencil
            </v-icon>
          </template>
          <template v-slot:no-data>
            <v-alert :value="true" color="#111c3d" icon="mdi-alert" outlined>No se encontro su busqueda</v-alert>
          </template>
          </v-data-table>
          <!-- alertas de las acciones que se hacen -->
          <v-snackbar
          v-model="snackbar"
          :bottom="y === 'bottom'"
          :left="x === 'left'"
          :multi-line="mode === 'multi-line'"
          :right="x === 'right'"
          :timeout="timeout"
          :top="y === 'top'"
          :vertical="mode === 'vertical'"
          color="#3945d0"
          style="color:white"
          >
          {{ text }}
          <v-btn color="#3945d0" depressed @click="snackbar = false">Cerrar</v-btn>
          </v-snackbar>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import env from "../env";
export default {
  data() {
    return {
      show: false,
      snackbar: false,
      y: "top",
      x: null,
      /* fechaN:false,
      fechaI:false, */
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      areas:[],
      cargos:[],
      rules: {
         required: value => !!value || 'Required.',
         counter: value => value.length <= 20 || 'Maximo 20 characteres',
         email: value => {
           const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
           return pattern.test(value) || 'Invalido e-mail.'
         }
       },
      dialog: false,
      headers: [
        {
          text: "Id",
          align: "left",
          value: "idCargo",
          align: "center",
          class: "column"
        },
        {
          text: "Cargo",
          value: "nombreCargo",
          align: "center",
          class: "column"
        },
        {
          text: "Area",
          value: "cc_nombre_area",
          align: "center",
          class: "column"
        },
        {
          text: "Acciones",
          value: "action",
          sortable: false,
          align: "center",
          class: "column"
        },
      ],
      defaultItem: {
        idArea:"",
        nombreCargo:""
      },
      editedIndex: -1,
      editedItem: {
        idArea:"",
        nombreCargo:""
      }
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Cargo" : "Editar Cargo";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  mounted() {
    this.obtenerTodo();
  },

  methods: {

  

  /**
   * Metodo para obtener roles y areas
   */
    obtenerTodo() {
      axios.get(`${env.endpoint}callcenter/areastodos`).then(res => (this.areas = res.data));
      axios.get(`${env.endpoint}user/cargos`).then(res => (this.cargos = res.data));
    },

  /**
   * Metodo para agregar fila de la tabla en la modal
   */
    editItem(item) {
      this.editedIndex = this.cargos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

  /**
   * Metodo para cerrar la modal
   */
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

  /**
   * Metodo para guardar y actualizar
   */
    save() {
     if (this.editedIndex > -1) {
        // obtiene los datos del arreglo para poder actualizar el usuario en el modal
        const cargo = JSON.stringify({
          id: this.editedItem.idCargo,
          idArea: this.editedItem.cc_id_area,
          nombreCargo: this.editedItem.nombreCargo,
        });
        
        // se seta los datos obtenidos del arreglo par modificarlo
        axios
          .get(`${env.endpoint}user/modificar_cargo?cargo=${cargo}`)
          .then(res => {
            if (res.data.mensaje === "cargo actualizado") {
              (this.snackbar = true),
                (this.text = "cargo actualizado satisfactoriamente");
            } else if (res.data.mensaje === "error en la actualizacion") {
              (this.snackbar = true), (this.text = "Error en la actualización");
            }
            this.obtenerTodo();
          });
      } else {
        // obtiene los datos del arreglo para despues setearlos en una variable nuevoUsuario y pasarselo al metodo
        const nuevaAplicacion = JSON.stringify({
          idArea: this.editedItem.idArea,
          nombreCargo: this.editedItem.nombreCargo,
        });        
        // se crea el usuario
        axios
          .get(`${env.endpoint}user/create_cargo?cargo=${nuevaAplicacion}`)
          .then(res => {
            if (res.data.mensaje === "cargo registrado") {
              (this.snackbar = true),
                (this.text = "Cargo registrado satisfactoriamente");
            } else if (res.data.mensaje === "error en el registro") {
              (this.snackbar = true), (this.text = "Error al registrar");
            } else if (res.data.mensaje === "error cargo existente") {
              (this.snackbar = true),
                (this.text = "El cargo ya existe en la plataforma");
            }
            // console.log(nuevoUsuario);
            this.obtenerTodo();
          });
        }
      this.close();
    }
  }
};
</script>